export default "__VITE_PUBLIC_ASSET__25e179a3__"